export default __webpack_public_path__ + "static/media/data.a29a9378.csv";